export default "__VITE_PUBLIC_ASSET__a0bdd2f6__"